import type { API } from '@setplex/tria-api'

import { use as http } from './http'

export function use(api: API) {
  http(api)
}
